import { adminRoutes } from 'app/constants/routes';
import { UserRoles } from 'app/constants/user';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import { SelectCarrier, SelectCarriers } from './SelectCarrierRouteComponents';

export const selectCarrierRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: SelectCarrier,
    path: `${adminRoutes.selectCarriers}/:id`,
    permitOnly: [UserRoles.CarrierSales, UserRoles.OpsLeadership, UserRoles.OpsManager],
  },
  {
    Component: SelectCarriers,
    path: adminRoutes.selectCarriers,
    permitOnly: [UserRoles.CarrierSales, UserRoles.OpsLeadership, UserRoles.OpsManager],
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
